const Field = require("components/forms/Field");

function Input({label, error, errorMessage, className, inputRef, children, required, suffix, ...props}) {
	return (
		<Field label={label} error={error} errorMessage={errorMessage} className={className} required={required}>
			<div className="input-wrap">
				<input ref={inputRef} {...props} />
				<span>{suffix}</span>
			</div>
			{children}
		</Field>
	);
}

module.exports = Input;


// WEBPACK FOOTER //
// ./resources/js/components/forms/SuffixedInput.js